var _defs, _path, _path2, _path3, _path4, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGooglePlayBadge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "google-play-badge",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 236.5,
    height: 70.074,
    viewBox: "0 0 236.5 70.074",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.908,
    y1: 1.032,
    x2: -0.383,
    y2: 0.36,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1.077,
    y1: 0.729,
    x2: -1.307,
    y2: 0.729,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.864,
    y1: -0.023,
    x2: -0.499,
    y2: -1.789,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -0.186,
    y1: 2.701,
    x2: 0.423,
    y2: 1.909,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M227.741,70.074H8.759A8.674,8.674,0,0,1,0,61.315V8.759A8.674,8.674,0,0,1,8.759,0H227.741A8.674,8.674,0,0,1,236.5,8.759V61.315A8.674,8.674,0,0,1,227.741,70.074Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M227.741,1.4A7.4,7.4,0,0,1,235.1,8.759V61.315a7.4,7.4,0,0,1-7.358,7.358H8.759A7.4,7.4,0,0,1,1.4,61.315V8.759A7.4,7.4,0,0,1,8.759,1.4H227.741m0-1.4H8.759A8.785,8.785,0,0,0,0,8.759V61.315a8.674,8.674,0,0,0,8.759,8.759H227.741a8.674,8.674,0,0,0,8.759-8.759V8.759A8.785,8.785,0,0,0,227.741,0Z",
    fill: "#a6a6a6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M51.911,12.681a4.772,4.772,0,0,1-1.226,3.5,5.5,5.5,0,0,1-7.708,0A5.151,5.151,0,0,1,41.4,12.331a5.151,5.151,0,0,1,1.577-3.854A5.151,5.151,0,0,1,46.831,6.9a4.665,4.665,0,0,1,2.1.526A3.815,3.815,0,0,1,50.51,8.652l-.876.876a3.267,3.267,0,0,0-2.8-1.226,3.486,3.486,0,0,0-2.8,1.226A3.609,3.609,0,0,0,42.8,12.506a3.609,3.609,0,0,0,1.226,2.978,4.511,4.511,0,0,0,2.8,1.226,3.842,3.842,0,0,0,2.978-1.226,2.9,2.9,0,0,0,.876-2.1H46.831v-1.4h5.08v.7ZM59.97,8.3H55.24V11.63h4.38v1.226H55.24v3.329h4.73v1.4H53.838V7.075H59.97Zm5.781,9.285h-1.4V8.3H61.371V7.075h7.358V8.3H65.751Zm8.059,0V7.075h1.4V17.586Zm7.358,0h-1.4V8.3H76.787V7.075H83.97V8.3H80.992v9.285Zm16.643-1.4a5.5,5.5,0,0,1-7.708,0,5.151,5.151,0,0,1-1.577-3.854A5.151,5.151,0,0,1,90.1,8.477a5.5,5.5,0,0,1,7.708,0,5.151,5.151,0,0,1,1.577,3.854A5.151,5.151,0,0,1,97.81,16.185Zm-6.657-.876a4.134,4.134,0,0,0,2.8,1.226,3.486,3.486,0,0,0,2.8-1.226,4.226,4.226,0,0,0,1.226-2.978,3.609,3.609,0,0,0-1.226-2.978,4.134,4.134,0,0,0-2.8-1.226,3.486,3.486,0,0,0-2.8,1.226,4.226,4.226,0,0,0-1.226,2.978A3.609,3.609,0,0,0,91.153,15.309Zm10.161,2.277V7.075h1.577l5.08,8.234V7.075h1.4V17.586h-1.4L102.54,9v8.584h-1.226Z",
    transform: "translate(31.127 5.188)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M88.4,25.334a7.37,7.37,0,0,0-7.533,7.533A7.477,7.477,0,0,0,88.4,40.4a7.37,7.37,0,0,0,7.533-7.533A7.268,7.268,0,0,0,88.4,25.334Zm0,11.913a4.348,4.348,0,0,1-4.2-4.555,4.348,4.348,0,0,1,4.2-4.555,4.244,4.244,0,0,1,4.2,4.555A4.348,4.348,0,0,1,88.4,37.246ZM72.108,25.334a7.37,7.37,0,0,0-7.533,7.533A7.477,7.477,0,0,0,72.108,40.4a7.37,7.37,0,0,0,7.533-7.533A7.268,7.268,0,0,0,72.108,25.334Zm0,11.913a4.348,4.348,0,0,1-4.2-4.555,4.348,4.348,0,0,1,4.2-4.555,4.244,4.244,0,0,1,4.2,4.555A4.348,4.348,0,0,1,72.108,37.246ZM52.662,27.611v3.153H60.2a6.624,6.624,0,0,1-1.752,4.029,7.754,7.754,0,0,1-5.781,2.277,8.156,8.156,0,0,1-8.234-8.409,8.264,8.264,0,0,1,8.234-8.409,8.686,8.686,0,0,1,5.781,2.277l2.277-2.277A11.226,11.226,0,0,0,52.837,17.1,11.818,11.818,0,0,0,41.1,28.662,11.818,11.818,0,0,0,52.837,40.224,10.082,10.082,0,0,0,60.9,36.9a10.546,10.546,0,0,0,2.8-7.358,6.569,6.569,0,0,0-.175-1.927H52.662ZM132.2,30.064c-.7-1.752-2.453-4.73-6.307-4.73s-7.007,2.978-7.007,7.533A7.331,7.331,0,0,0,126.24,40.4a7.186,7.186,0,0,0,6.131-3.329l-2.453-1.752a4.27,4.27,0,0,1-3.679,2.1,3.8,3.8,0,0,1-3.679-2.277l9.986-4.2-.35-.876Zm-10.161,2.453a4.256,4.256,0,0,1,3.854-4.38,3.1,3.1,0,0,1,2.8,1.577l-6.657,2.8ZM113.8,39.7h3.329V17.8H113.8ZM108.546,26.91a5.768,5.768,0,0,0-4.029-1.752,7.527,7.527,0,0,0-7.183,7.533,7.254,7.254,0,0,0,7.183,7.358,5.03,5.03,0,0,0,3.854-1.752h.175v1.051c0,2.8-1.577,4.38-4.029,4.38a3.892,3.892,0,0,1-3.679-2.628l-2.8,1.226a7.227,7.227,0,0,0,6.657,4.38c3.854,0,7.007-2.277,7.007-7.708V25.684h-3.153V26.91Zm-3.854,10.336a4.348,4.348,0,0,1-4.2-4.555,4.348,4.348,0,0,1,4.2-4.555c2.277,0,4.029,1.927,4.029,4.555S106.97,37.246,104.692,37.246ZM147.437,17.8h-7.883V39.7h3.329V31.465h4.555a6.841,6.841,0,1,0,0-13.664Zm.175,10.511h-4.73V20.779h4.73a3.848,3.848,0,0,1,3.854,3.679,4.009,4.009,0,0,1-3.854,3.854Zm20.146-3.153c-2.453,0-4.905,1.051-5.781,3.329l2.978,1.226a3.094,3.094,0,0,1,2.978-1.577,3.292,3.292,0,0,1,3.5,2.8v.175a6.949,6.949,0,0,0-3.329-.876c-3.153,0-6.307,1.752-6.307,4.905,0,2.978,2.628,4.905,5.431,4.905a4.93,4.93,0,0,0,4.2-2.1h.175V39.7h3.153V31.29c-.35-3.854-3.329-6.131-7.007-6.131Zm-.35,12.088c-1.051,0-2.628-.526-2.628-1.927,0-1.752,1.927-2.277,3.5-2.277a6.775,6.775,0,0,1,2.978.7A4.08,4.08,0,0,1,167.409,37.246ZM185.8,25.684l-3.679,9.46h-.175l-3.854-9.46h-3.5L180.372,39l-3.329,7.358h3.329l8.934-20.672h-3.5ZM156.372,39.7H159.7V17.8h-3.329Z",
    transform: "translate(30.901 12.857)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_292",
    "data-name": "Group 292",
    transform: "translate(17.519 12.521)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M10.7,7.5A3.425,3.425,0,0,0,10,9.953V48.669a3.466,3.466,0,0,0,.876,2.453l.175.175L32.774,29.573v-.35Z",
    transform: "translate(-10 -6.882)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M30.083,30.691,22.9,23.508v-.526L30.083,15.8l.175.175,8.584,4.905c2.453,1.4,2.453,3.679,0,5.08Z",
    transform: "translate(-0.301 -0.642)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M39.656,27.358,32.3,20,10.4,41.9c.876.876,2.1.876,3.679.175L39.656,27.358",
    transform: "translate(-9.699 2.516)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M39.656,22.288,14.079,7.747c-1.577-.876-2.8-.7-3.679.175L32.3,29.645l7.358-7.358Z",
    transform: "translate(-9.699 -7.129)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M39.481,24.1l-25.4,14.365a2.865,2.865,0,0,1-3.5,0l-.175.175.175.175a2.865,2.865,0,0,0,3.5,0Z",
    transform: "translate(-9.699 5.599)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M10.7,41.548A3.425,3.425,0,0,1,10,39.1v.175a3.466,3.466,0,0,0,.876,2.453v-.175H10.7Zm37.84-19.27-8.759,4.905.175.175,8.584-4.905A2.912,2.912,0,0,0,50.293,20C50.293,20.876,49.592,21.577,48.541,22.277Z",
    transform: "translate(-10 2.516)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M14.38,7.94,48.541,27.386c1.051.7,1.752,1.4,1.752,2.277a2.912,2.912,0,0,0-1.752-2.453L14.38,7.765c-2.453-1.4-4.38-.35-4.38,2.453v.175C10,7.765,11.927,6.539,14.38,7.94Z",
    transform: "translate(-10 -7.147)",
    fill: "#fff",
    opacity: 0.25
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayBadge);
export default __webpack_public_path__ + "static/media/google-play-badge.dcd6e7797172694cbeda3171b02c458b.svg";
export { ForwardRef as ReactComponent };